import { render, staticRenderFns } from "./expenditure.vue?vue&type=template&id=7afe80f3&"
import script from "./expenditure.vue?vue&type=script&lang=js&"
export * from "./expenditure.vue?vue&type=script&lang=js&"
import style0 from "./expenditure.vue?vue&type=style&index=0&id=7afe80f3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports